export default __webpack_public_path__ + "static/media/38.ce3b658d.png";